import {
  IUpdateOffersData,
  UPDATE_OFFERS_DATA,
  IToggleLoadingGetOffersData,
  TOGGLE_LOADING_GETOFFERS,
  UPDATE_HOME_SEO_DATA,
  IUpdateSEOData,
  ISeoData,
} from './types';

export function updateSEOData(homeSeoData: ISeoData): IUpdateSEOData {
  return {
    type: UPDATE_HOME_SEO_DATA,
    homeSeoData,
  };
}

export function updateOffersDataAction(
  actionData: IUpdateOffersData['actionData'],
): IUpdateOffersData {
  return {
    type: UPDATE_OFFERS_DATA,
    actionData,
  };
}

export function toggleLoadingGetOffersAction(
  actionData: IToggleLoadingGetOffersData['actionData'],
): IToggleLoadingGetOffersData {
  return {
    type: TOGGLE_LOADING_GETOFFERS,
    actionData,
  };
}
